import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#f8faff] dark:bg-[#0a0e17] text-gray-900 dark:text-white" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Outlet data-id="element-3" />
      </main>
      <Footer data-id="element-4" />
    </div>;
}